<template>
  <router-view
    v-slot="{ Component }"
    v-if="!isLoadingUser && !isLoadingFeatures"
  >
    <transition name="fade" mode="out-in" appear>
      <component :is="Component" />
    </transition>
  </router-view>
  <Notification />
  <Loading
    :active="isLoadingUser || isLoadingFeatures"
    :can-cancel="false"
    :is-full-page="true"
    color="#0C1E67"
    loader="dots"
    :opacity="0"
  />

  <Loading
    :active="isLoadingContent || isFullPageLoader"
    :can-cancel="false"
    :is-full-page="true"
    color="#0C1E67"
    loader="dots"
    :opacity="0.7"
  />

  <ProgressLoader v-if="isGenerating" />
  <teleport to="body">
    <ProgressLoader v-if="isSaving" text="Zapisywanie..." />
  </teleport>
</template>

<script>
import Loading from "vue-loading-overlay";
import { mapActions, mapGetters } from "vuex";
import Notification from "@/layouts/Notification";
import ProgressLoader from "@/components/Core/ProgressLoader.vue";

export default {
  name: "App",
  components: {
    ProgressLoader,
    Notification,
    Loading,
  },

  computed: {
    ...mapGetters({
      isLoadingFeatures: "features/isLoadingFeatures",
      isLoadingUser: "loader/getUserLoaderStatus",
      isLoadingContent: "loader/getContentLoaderStatus",
      isFullPageLoader: "loader/getFullPageLoader",
      isGenerating: "loader/getGenerateLoader",
      isSaving: "loader/getSavingLoader",
    }),
  },
  methods: {
    ...mapActions({
      initCurrentLanguage: "language/initCurrentLanguage",
      fetchFeatures: "features/fetchFeatures",
    }),
  },
  created() {
    this.initCurrentLanguage();
    this.fetchFeatures();
  },
};
</script>
